import { useEffect, useState } from "react";
import { ButtonGroup, Dropdown, DropdownButton, Form, FormControl, FormLabel } from "react-bootstrap";
import { MainLayout } from "../layout/MainLayout";
import { PosTask, PreTask, SubTask, SubTaskGroup, SubTaskPrompt, SubTaskRole, Task, aimsOfTask, proficiencyLevelsOfTask } from "../interfaces/Task";
import NewPreTaskText from "./PreTaskTypes/NewPreTaskText";
import PreTaskTeaser from "./PreTaskTeaser";
import NewPreTaskAudio from "./PreTaskTypes/NewPreTaskAudio";
import SubTaskTeaser from "./SubTask/SubTaskTeaser";
import Help from "../elements/HelpContent";
import { useParams } from "react-router-dom";
import NewPreTaskVideo from "./PreTaskTypes/NewPreTaskVideo";
import NewPreTaskDialog from "./PreTaskTypes/NewPreTaskDialog";
import NewPreTaskPhoto from "./PreTaskTypes/NewPreTaskPhoto";
import NewPreTaskSpeech from "./PreTaskTypes/NewPreTaskSpeech";
import NewPosTaskExplanationText from "./PosTaskTypes/NewPosTaskExplanationText";
import PosTaskTeaser from "./PosTaskTeaser";
import NewPosTaskReport from "./PosTaskTypes/NewPosTaskReport";
import NewPosTaskTME from "./PosTaskTypes/NewPosTaskTME";
import NewPosTaskTeacherFeedback from "./PosTaskTypes/NewPosTaskTeacherFeedback";
import NewPosTaskExercises from "./PosTaskTypes/NewPosTaskExercises";
import { useNavigate } from "react-router-dom";
import NewPreTaskActivity from "./PreTaskTypes/NewPreTaskActivity";
import NewPreTaskGame from "./PreTaskTypes/NewPreTaskGame";
import NewPreTaskWarmUp from "./PreTaskTypes/NewPreTaskWarmUp";
import NewPosTaskRepetition from "./PosTaskTypes/NewPosTaskRepetition";
import NewPosTaskInteractionActivity from "./PosTaskTypes/NewPosTaskInteractionActivity";
import NewPosTaskText from "./PosTaskTypes/NewPosTaskText";
import NewPosTaskAudio from "./PosTaskTypes/NewPosTaskAudio";
import NewPosTaskVideo from "./PosTaskTypes/NewPosTaskVideo";
import NewPosTaskDialog from "./PosTaskTypes/NewPosTaskDialog";
import NewPosTaskPhoto from "./PosTaskTypes/NewPosTaskPhoto";
import NewPosTaskGame from "./PosTaskTypes/NewPosTaskGame";
import { Media } from "../interfaces/Media";
import { useTranslation } from "react-i18next";
import { TaskTags } from "./TaskTags";
import { handleApiError, safeJsonParse, showErrorNotification } from "../../utils/api";

export default function EditTask() {
    const { t } = useTranslation();

    const params= useParams();
    const navigate = useNavigate();

    const [showNewPreTaskText, setShowNewPreTaskText] = useState(false);
    const [showNewPreTaskAudio, setShowNewPreTaskAudio] = useState(false);
    const [showNewPreTaskVideo, setShowNewPreTaskVideo] = useState(false);
    const [showNewPreTaskDialog, setShowNewPreTaskDialog] = useState(false);
    const [showNewPreTaskPhoto, setShowNewPreTaskPhoto] = useState(false);
    const [showNewPreTaskSpeech, setShowNewPreTaskSpeech] = useState(false);
    const [showNewPreTaskActivity, setShowNewPreTaskActivity] = useState(false);
    const [showNewPreTaskGame, setShowNewPreTaskGame] = useState(false);
    const [showNewPreTaskWarmUp, setShowNewPreTaskWarmUp] = useState(false);
    const [showNewPosTaskExplanationText, setShowNewPosTaskExplanationText] = useState(false);
    const [showNewPosTaskRepetition, setShowNewPosTaskRepetition] = useState(false);
    const [showNewPosTaskInteractionActivity, setShowNewPosTaskInteractionActivity] = useState(false);
    const [showNewPosTaskReport, setShowNewPosTaskReport] = useState(false);
    const [showNewPosTaskTME, setShowNewPosTaskTME] = useState(false);
    const [showNewPosTaskTeacherFeedback, setShowNewPosTaskTeacherFeedback] = useState(false);
    const [showNewPosTaskExercises, setShowNewPosTaskExercises] = useState(false);
    const [showNewPosTaskText, setShowNewPosTaskText] = useState(false);
    const [showNewPosTaskAudio, setShowNewPosTaskAudio] = useState(false);
    const [showNewPosTaskVideo, setShowNewPosTaskVideo] = useState(false);
    const [showNewPosTaskDialog, setShowNewPosTaskDialog] = useState(false);
    const [showNewPosTaskPhoto, setShowNewPosTaskPhoto] = useState(false);
    const [showNewPosTaskGame, setShowNewPosTaskGame] = useState(false);

    const [task, setTask] = useState<Task>({
        _id: '',
        name: '',
        pretasks: [],
        tasks: [],
        postasks: [],
        updated: new Date(),
        userId: '',
        active: false,
        authorship: '',
        aims: [],
        aim_other: '',
        specific_aim: '',
        proficiency_level: [],
        proficiency_level_comments: '',
        sessions: [],
        clonned: false,
        original_source: '',
        original_task: '',
        weight: 0,
        task_language: localStorage.getItem('taskgen_interface_language') ?? 'en'
    });
    const [showTaskInfo, setShowTaskInfo] = useState(false);
    const [originalAuthor, setOriginalAuthor] = useState('');

    /* Pretask */
    const newPreTaskTextShow = () => {
        setShowNewPreTaskText(true);
    }

    const newPreTaskTextHide = () => {
        setShowNewPreTaskText(false);
    }

    const newPreTaskAudioShow = () => {
        setShowNewPreTaskAudio(true);
    }

    const newPreTaskVideoShow = () => {
        setShowNewPreTaskVideo(true);
    }

    const newPreTaskDialogShow = () => {
        setShowNewPreTaskDialog(true);
    }

    const newPreTaskPhotoShow = () => {
        setShowNewPreTaskPhoto(true);
    }

    const newPreTaskSpeechShow = () => {
        setShowNewPreTaskSpeech(true);
    }

    const newPreTaskActivityShow = () => {
        setShowNewPreTaskActivity(true);
    }

    const newPreTaskGameShow = () => {
        setShowNewPreTaskGame(true);
    }

    const newPreTaskWarmUpShow = () => {
        setShowNewPreTaskWarmUp(true);
    }

    const newPosTaskAudioShow = () => {
        setShowNewPosTaskAudio(true);
    }

    const newPosTaskDialogShow = () => {
        setShowNewPosTaskDialog(true);
    }

    const newPosTaskGameShow = () => {
        setShowNewPosTaskGame(true);
    }

    const newPosTaskPhotoShow = () => {
        setShowNewPosTaskPhoto(true);
    }

    const newPosTaskTextShow = () => {
        setShowNewPosTaskText(true);
    }

    const newPosTaskVideoShow = () => {
        setShowNewPosTaskVideo(true);
    }

    const newPosTaskRepetitionShow = () => {
        setShowNewPosTaskRepetition(true);
    }

    const newPosTaskInteractionActivityShow = () => {
        setShowNewPosTaskInteractionActivity(true);
    }

    const newPosTaskExplanationTextShow = () => {
        setShowNewPosTaskExplanationText(true);
    }

    const newPosTaskReportShow = () => {
        setShowNewPosTaskReport(true);
    }

    const newPosTaskTMEShow = () => {
        setShowNewPosTaskTME(true);
    }

    const newPosTaskTeacherFeedbackShow = () => {
        setShowNewPosTaskTeacherFeedback(true);
    }

    const newPosTaskExercisesShow = () => {
        setShowNewPosTaskExercises(true);
    }

    const newPreTaskAudioHide = () => {
        setShowNewPreTaskAudio(false);
    }

    const newPreTaskVideoHide = () => {
        setShowNewPreTaskVideo(false);
    }

    const newPreTaskDialogHide = () => {
        setShowNewPreTaskDialog(false);
    }

    const newPreTaskPhotoHide = () => {
        setShowNewPreTaskPhoto(false);
    }

    const newPreTaskSpeechHide = () => {
        setShowNewPreTaskSpeech(false);
    }

    const newPreTaskActivityHide = () => {
        setShowNewPreTaskActivity(false);
    }

    const newPreTaskGameHide = () => {
        setShowNewPreTaskGame(false);
    }

    const newPreTaskWarmUpHide = () => {
        setShowNewPreTaskWarmUp(false);
    }

    const newPosTaskAudioHide = () => {
        setShowNewPosTaskAudio(false);
    }

    const newPosTaskDialogHide = () => {
        setShowNewPosTaskDialog(false);
    }


    const newPosTaskGameHide = () => {
        setShowNewPosTaskGame(false);
    }


    const newPosTaskPhotoHide = () => {
        setShowNewPosTaskPhoto(false);
    }

    const newPosTaskTextHide = () => {
        setShowNewPosTaskText(false);
    }

    const newPosTaskVideoHide = () => {
        setShowNewPosTaskVideo(false);
    }

    const newPosTaskRepetitionHide = () => {
        setShowNewPosTaskRepetition(false);
    }

    const newPosTaskInteractionActivityHide = () => {
        setShowNewPosTaskInteractionActivity(false);
    }

    const newPosTaskExplanationTextHide = () => {
        setShowNewPosTaskExplanationText(false);
    }

    const newPosTaskReportHide = () => {
        setShowNewPosTaskReport(false);
    }

    const newPosTaskTMEHide = () => {
        setShowNewPosTaskTME(false);
    }

    const newPosTaskTeacherFeedbackHide = () => {
        setShowNewPosTaskTeacherFeedback(false);
    }

    const newPosTaskExercisesHide = () => {
        setShowNewPosTaskExercises(false);
    }

    const handleUpdatePretask = (pretask: PreTask) => {
        let newPreTask: any = {};
        switch (pretask.type) {
            case 'text':
                newPreTask = Object.assign({}, pretask);
                break;
            case 'audio':
                newPreTask = Object.assign({}, pretask);
                break; 
            case 'video':
                newPreTask = Object.assign({}, pretask);
                break; 
            case 'dialog':
                newPreTask = Object.assign({}, pretask);
                break;   
            case 'photo':
                newPreTask = Object.assign({}, pretask);
                break;   
            case 'speech':
                newPreTask = Object.assign({}, pretask);
                break;   
            case 'activity':
                newPreTask = Object.assign({}, pretask);
                break;   
            case 'game':
                newPreTask = Object.assign({}, pretask);
                break;   
            case 'warmup':
                newPreTask = Object.assign({}, pretask);
                break;       
            default:
                newPreTask = Object.assign({}, pretask);

        }
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(pretask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/pretask/' + pretask._id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                const newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleDeletePretask = (id: string) => {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/pretask/' + id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then((data: Task) => {
                if (!data) return;
                const newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleSortUpSubtask = (position: number) => {
        if (position > 0) {
            const newTask = Object.assign({}, task);
            const prevSubTask: SubTask = Object.assign({}, task.tasks[position - 1]);
            const currSubTask: SubTask = Object.assign({}, task.tasks[position]);
            newTask.tasks = task.tasks.map((pt: SubTask, index) => {
                if (index == position - 1) {
                    return (currSubTask);
                }
                if (index == position) {
                    return (prevSubTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleSortDownSubtask = (position: number) => {
        if (position < task.tasks.length - 1) {
            const newTask = Object.assign({}, task);
            const prevSubTask: SubTask = Object.assign({}, task.tasks[position + 1]);
            const currSubTask: SubTask = Object.assign({}, task.tasks[position]);
            newTask.tasks = task.tasks.map((pt: SubTask, index) => {
                if (index == position + 1) {
                    return (currSubTask);
                }
                if (index == position) {
                    return (prevSubTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleSortUpPretask = (position: number) => {
        if (position > 0) {
            const newTask = Object.assign({}, task);
            const prevPreTask: PreTask = Object.assign({}, task.pretasks[position - 1]);
            const currPreTask: PreTask = Object.assign({}, task.pretasks[position]);
            newTask.pretasks = task.pretasks.map((pt: PreTask, index) => {
                if (index == position - 1) {
                    return (currPreTask);
                }
                if (index == position) {
                    return (prevPreTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleSortDownPretask = (position: number) => {
        if (position < task.pretasks.length - 1) {
            const newTask = Object.assign({}, task);
            const prevPreTask: PreTask = Object.assign({}, task.pretasks[position + 1]);
            const currPreTask: PreTask = Object.assign({}, task.pretasks[position]);
            newTask.pretasks = task.pretasks.map((pt: PreTask, index) => {
                if (index == position + 1) {
                    return (currPreTask);
                }
                if (index == position) {
                    return (prevPreTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleSortUpPostask = (position: number) => {
        if (position > 0) {
            const newTask = Object.assign({}, task);
            const prevPosTask: PosTask = Object.assign({}, task.postasks[position - 1]);
            const currPosTask: PosTask = Object.assign({}, task.postasks[position]);
            newTask.postasks = task.postasks.map((pt: PosTask, index) => {
                if (index == position - 1) {
                    return (currPosTask);
                }
                if (index == position) {
                    return (prevPosTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleSortDownPostask = (position: number) => {
        if (position < task.postasks.length - 1) {
            const newTask = Object.assign({}, task);
            const prevPosTask: PosTask = Object.assign({}, task.postasks[position + 1]);
            const currPosTask: PosTask = Object.assign({}, task.postasks[position]);
            newTask.postasks = task.postasks.map((pt: PosTask, index) => {
                if (index == position + 1) {
                    return (currPosTask);
                }
                if (index == position) {
                    return (prevPosTask);
                }
                return (pt);
            });

           const requestOptions = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newTask)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id, requestOptions)
                .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
                .then(data => {
                    if (!data) return;
                    const newTask = Object.assign({}, data);
                    setTask(newTask);
                });
        }
    }

    const handleUpdatePosTask = (postask: PosTask) => {
        let newPosTask: any = {};
        switch (postask.type) {
            case 'repetition':
                newPosTask = Object.assign({}, postask);
                break;
            case 'interactionactivity':
                newPosTask = Object.assign({}, postask);
                break;
            case 'explanationtext':
                newPosTask = Object.assign({}, postask);
                break;
            case 'report':
                newPosTask = Object.assign({}, postask);
                break;  
            case 'tme':
                newPosTask = Object.assign({}, postask);
                break;   
            case 'teacherfeedback':
                newPosTask = Object.assign({}, postask);
                break;   
            case 'exercises':
                newPosTask = Object.assign({}, postask);
                break;  
            case 'text':
                newPosTask = Object.assign({}, postask);
                break;
            case 'audio':
                newPosTask = Object.assign({}, postask);
                break; 
            case 'video':
                newPosTask = Object.assign({}, postask);
                break; 
            case 'dialog':
                newPosTask = Object.assign({}, postask);
                break;   
            case 'photo':
                newPosTask = Object.assign({}, postask);
                break;   
            case 'game':
                newPosTask = Object.assign({}, postask);
                break;
            default:
                newPosTask = Object.assign({}, {
                    name: postask.name,
                    updated: postask.updated,
                    type: postask.type
                });

        }
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(postask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/postask/' + postask._id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                const newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleDeletePosTask = (id: string) => {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/postask/' + id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then((data: Task) => {
                if (!data) return;
                const newTask: Task = data;
                setTask(newTask);
            });
    }

    /* Subtask */
    const handleNewSubTask = () => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                name: 'New task',
                groups: [],
                roles: [],
                prompts: [],   
                goal: '',
                students: 0,
                grouping: '',
                studentsPerGroup: 0
            })
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/subtask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleCloneSubTask = (subtask: SubTask) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                name: subtask.name + ' ' + t("(copy)"),
                groups: subtask.groups.map((g: SubTaskGroup) => { return g; }),
                roles: subtask.roles.map((r: SubTaskRole) => { return r; }),
                prompts: subtask.prompts.map((p: SubTaskPrompt) => { return p; }),  
                goal: subtask.goal,
                students: subtask.students,
                grouping: subtask.grouping,
                studentsPerGroup: subtask.studentsPerGroup
            })
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/subtask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleUpdateSubtask = (subtask: SubTask) => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(subtask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/subtask/' + subtask._id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                const newTask = Object.assign({}, data);
                setTask(newTask);
            });
    }

    const handleDeleteSubtask = (id: string) => {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/subtask/' + id, requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then((data: Task) => {
                if (!data) return;
                const newTask: Task = data;
                setTask(newTask);
            });
    }

    const newPreTaskSave = (t: PreTask) => {
        let newPreTask: any = {};
        switch (t.type) {
            case 'text':
                newPreTask = Object.assign({}, t);
                break;
            case 'audio':
                newPreTask = Object.assign({}, t);
                break; 
            case 'video':
                newPreTask = Object.assign({}, t);
                break; 
            case 'dialog':
                newPreTask = Object.assign({}, t);
                break;   
            case 'photo':
                newPreTask = Object.assign({}, t);
                break;   
            case 'speech':
                newPreTask = Object.assign({}, t);
                break; 
            case 'activity':
                newPreTask = Object.assign({}, t);
                break;  
            case 'game':
                newPreTask = Object.assign({}, t);
                break;
            case 'warmup':
                newPreTask = Object.assign({}, t);
                break;
            default:
                newPreTask = Object.assign({}, t);

        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newPreTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/pretask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
                setShowNewPreTaskText(false);
                setShowNewPreTaskAudio(false);
                setShowNewPreTaskVideo(false);
                setShowNewPreTaskDialog(false);
                setShowNewPreTaskPhoto(false);
                setShowNewPreTaskSpeech(false);
                setShowNewPreTaskActivity(false);
                setShowNewPreTaskGame(false);
                setShowNewPreTaskWarmUp(false);
            });
    }

    const handleClonePretask = (p: number) => {
        const newPreTask: PreTask = Object.assign({}, task.pretasks[p]);
        newPreTask._id = '';
        newPreTask.name = newPreTask.name + ' ' + t("(copy)");
        newPreTask.updated = new Date();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newPreTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/pretask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
                setShowNewPreTaskText(false);
                setShowNewPreTaskAudio(false);
                setShowNewPreTaskVideo(false);
                setShowNewPreTaskDialog(false);
                setShowNewPreTaskPhoto(false);
                setShowNewPreTaskSpeech(false);
                setShowNewPreTaskActivity(false);
                setShowNewPreTaskGame(false);
                setShowNewPreTaskWarmUp(false);
            });
    }

    const handleCloneAs = (id: string, direction: string) => {
        if (direction == 'pre-to-pos') {
            const preTaskIndex = task.pretasks.findIndex((t: PreTask) => t._id == id);
            if (preTaskIndex !== -1) {
                const preTask: PreTask = Object.assign({}, task.pretasks[preTaskIndex]);
                const newPosTask: PosTask = {
                    _id: '',
                    type: preTask.type,
                    name: preTask.name,
                    instructions: preTask.instructions,
                    text: preTask.text,
                    formatted_text: preTask.formatted_text,
                    media: preTask.media !== undefined ? preTask.media.map((m: Media) => { return m}) : [],
                    students: false,
                    teachers: false,
                    teacher_notes: preTask.teacher_notes,
                    updated: new Date(),
                    session: ''
                };
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newPosTask)
                };
                fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/postask', requestOptions)
                    .then(response => {
                        if (handleApiError(response, navigate)) {
                            return null;
                        }
                        return safeJsonParse(response);
                    })
                    .then(data => {
                        if (!data) return;
                        let newTask = Object.assign({}, data);
                        setTask(newTask);
                        alert(t("Pre-Task has been clonned as a Pos-Task."));
                    });
            }
        }

        if (direction == 'pos-to-pre') {
            const posTaskIndex = task.postasks.findIndex((t: PosTask) => t._id == id);
            if (posTaskIndex !== -1) {
                const posTask: PosTask = Object.assign({}, task.postasks[posTaskIndex]);
                const newPreTask: PosTask = {
                    _id: '',
                    type: posTask.type,
                    name: posTask.name,
                    instructions: posTask.instructions,
                    text: posTask.text,
                    formatted_text: posTask.formatted_text,
                    media: posTask.media !== undefined ? posTask.media.map((m: Media) => { return m}) : [],
                    students: false,
                    teachers: false,
                    teacher_notes: posTask.teacher_notes,
                    updated: new Date(),
                    session: ''
                };
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newPreTask)
                };
                fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/pretask', requestOptions)
                    .then(response => {
                        if (handleApiError(response, navigate)) {
                            return null;
                        }
                        return safeJsonParse(response);
                    })
                    .then(data => {
                        if (!data) return;
                        let newTask = Object.assign({}, data);
                        setTask(newTask);
                        setShowNewPreTaskText(false);
                        setShowNewPreTaskAudio(false);
                        setShowNewPreTaskVideo(false);
                        setShowNewPreTaskDialog(false);
                        setShowNewPreTaskPhoto(false);
                        setShowNewPreTaskSpeech(false);
                        setShowNewPreTaskActivity(false);
                        setShowNewPreTaskGame(false);
                        setShowNewPreTaskWarmUp(false);
                        alert(t("Pos-Task has been clonned as a Pre-Task."));
                    });
            }
        }
    }

    const newPosTaskSave = (t: PosTask) => {
        let newPosTask: any = {};
        switch (t.type) {
            case 'repetition':
                newPosTask = Object.assign({}, t);
                break;
            case 'interactionactivity':
                newPosTask = Object.assign({}, t);
                break;
            case 'explanationtext':
                newPosTask = Object.assign({}, t);
                break;
            case 'report':
                newPosTask = Object.assign({}, t);
                break;  
            case 'tme':
                newPosTask = Object.assign({}, t);
                break;   
            case 'teacherfeedback':
                newPosTask = Object.assign({}, t);
                break;   
            case 'exercises':
                newPosTask = Object.assign({}, t);
                break; 
            case 'text':
                newPosTask = Object.assign({}, t);
                break;
            case 'audio':
                newPosTask = Object.assign({}, t);
                break; 
            case 'video':
                newPosTask = Object.assign({}, t);
                break; 
            case 'dialog':
                newPosTask = Object.assign({}, t);
                break;   
            case 'photo':
                newPosTask = Object.assign({}, t);
                break;   
            case 'game':
                newPosTask = Object.assign({}, t);
                break;
            default:
                newPosTask = Object.assign({}, {
                    name: t.name,
                    updated: t.updated,
                    type: t.type
                });

        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newPosTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/postask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
                setShowNewPosTaskRepetition(false);
                setShowNewPosTaskInteractionActivity(false);
                setShowNewPosTaskExplanationText(false);
                setShowNewPosTaskReport(false);
                setShowNewPosTaskTME(false);
                setShowNewPosTaskTeacherFeedback(false);
                setShowNewPosTaskExercises(false);
                setShowNewPosTaskText(false);
                setShowNewPosTaskAudio(false);
                setShowNewPosTaskVideo(false);
                setShowNewPosTaskDialog(false);
                setShowNewPosTaskPhoto(false);
                setShowNewPosTaskGame(false);
            });
    }

    const handleClonePostask = (p: number) => {
        const newPosTask: PosTask = Object.assign({}, task.postasks[p]);
        newPosTask._id = '';
        newPosTask.name = newPosTask.name + ' ' + t("(copy)");
        newPosTask.updated = new Date();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newPosTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + task._id + '/postask', requestOptions)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                let newTask = Object.assign({}, data);
                setTask(newTask);
                setShowNewPosTaskRepetition(false);
                setShowNewPosTaskInteractionActivity(false);
                setShowNewPosTaskExplanationText(false);
                setShowNewPosTaskReport(false);
                setShowNewPosTaskTME(false);
                setShowNewPosTaskTeacherFeedback(false);
                setShowNewPosTaskExercises(false);
                setShowNewPosTaskText(false);
                setShowNewPosTaskAudio(false);
                setShowNewPosTaskVideo(false);
                setShowNewPosTaskDialog(false);
                setShowNewPosTaskPhoto(false);
                setShowNewPosTaskGame(false);

            });
    }

    const handleNameChange = (e: any) => {
        const newTask = task;
        newTask.name = e.target.value;
        setTask(newTask);
    }

    const handleNameBlur = (e: any) => {
        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(task)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/change-name/' + task._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
            });
    }

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + params.id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                // Allow access if user is owner OR has edit permission on shared task
                const isOwner = data.isOwner === true;
                const canEdit = data.canEdit === true;
                if (!isOwner && !canEdit) {
                    showErrorNotification(t('You do not have permission to edit this task.'));
                    navigate('/dashboard');
                    return;
                }
                if (data.aims === undefined) {
                    data.aims = [];
                }
                if (data.proficiency_level === undefined) {
                    data.proficiency_level = [];
                }
                // Ensure task_language is set, default to 'en' if not present
                if (!data.task_language) {
                    data.task_language = 'en';
                }
                setTask(data);
            });
    }, []);

    // Load the original author (the user who created the task) for read-only display
    useEffect(() => {
        if (!task.userId) return;
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/user/' + task.userId, requestOptions)
            .then(response => response.ok ? safeJsonParse(response) : null)
            .then(data => {
                if (!data || !data.profile) return;
                const name = [data.profile.firstname, data.profile.lastname].filter(Boolean).join(' ').trim();
                setOriginalAuthor(name);
            })
            .catch(() => {});
    }, [task.userId]);

    const nullSubmit = (e: any) => {
        e.preventDefault();
    }

    const toggleShowTaskInfo = () => {
        setShowTaskInfo(!showTaskInfo);
    }

    const handleAuthorshipChange = (e: any) => {
        const newTask = Object.assign({}, task);
        newTask.authorship = e.target.value;
        setTask(newTask);
    }

    const handleSaveProperties = (e: any) => {
        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(task)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/properties/' + task._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
            });
    }

    const handleChangeGeneralAim = (e: any) => {
        const newTask = Object.assign({}, task);
        const index: number = newTask.aims.indexOf(parseInt(e.target.value));
        if (index === -1) {
            newTask.aims.push(parseInt(e.target.value));
        } else {
            newTask.aims = newTask.aims.filter((a: number) => a != parseInt(e.target.value));
        }
        setTask(newTask);
        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/properties/' + newTask._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
            });
    }

    const handleAimOtherChange = (e: any) => {
        const newTask = Object.assign({}, task);
        newTask.aim_other = e.target.value;
        setTask(newTask);
    }

    const handleChangeSpecificAim = (e: any) => {
        const newTask = Object.assign({}, task);
        newTask.specific_aim = e.target.value;
        setTask(newTask);
        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/properties/' + newTask._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
            });
    }

    const handleChangeProficiencyLevel = (e: any) => {
        const newTask = Object.assign({}, task);
        const index: number = newTask.proficiency_level.indexOf(parseInt(e.target.value));
        if (index === -1) {
            newTask.proficiency_level.push(parseInt(e.target.value));
        } else {
            newTask.proficiency_level = newTask.proficiency_level.filter((a: number) => a != parseInt(e.target.value));
        }
        setTask(newTask);
        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/properties/' + newTask._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
            });
    }

    const handleChangeProficiencyLevelComments = (e: any) => {
        const newTask = Object.assign({}, task);
        newTask.proficiency_level_comments = e.target.value;
        setTask(newTask);
    }

    const handleTaskLanguageChange = (e: any) => {
        const newTask = Object.assign({}, task);
        newTask.task_language = e.target.value;
        setTask(newTask);

        const requestOptionsPost = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify(newTask)
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/properties/' + newTask._id, requestOptionsPost)
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;

            })
            .catch(error => {
                console.error('Error saving task language:', error);
            });
    }

    const openOutput = () => {
        navigate('/preview-task/' + params.id);
    }

    return (
        <MainLayout>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="edit-task-container">
                                    <div className="inner">
                                        <div className="task-data">
                                            <Form className="task-name-form" onSubmit={ nullSubmit }>
                                                <div className="form-field">
                                                    <FormControl type="text" defaultValue={ task.name }
                                                        placeholder={ t("Write the name of the task") }
                                                        required={ true } name="name" onChange={ handleNameChange } onBlur={ handleNameBlur } />
                                                    <a className="toggle-info" onClick={ toggleShowTaskInfo }>{ t("Task metadata") }</a>
                                                </div>
                                            </Form>
                                            <div className="task-more-options">
                                                <a className="output" title={ t("My design") } onClick={ openOutput }>{ t("My design") }</a>
                                            </div>
                                        </div>
                                        <div className={ 'task-info-elems-container' + (showTaskInfo ? ' show' : '')}>
                                            <div className="inner row">
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <Form.Group className="field field-task-language">
                                                        <Form.Label className="label">{ t("Task language") }</Form.Label>
                                                        <Form.Select name="task_language" value={ task.task_language } onChange={ handleTaskLanguageChange }>
                                                            <option value="ca">{ t("Catalan") }</option>
                                                            <option value="en">{ t("English") }</option>
                                                            <option value="es">{ t("Spanish") }</option>
                                                            <option value="ru">{ t("Russian") }</option>
                                                        </Form.Select>
                                                        <div className="control-description">
                                                            { t("Language in which the task is designed") }
                                                        </div>
                                                    </Form.Group>
                                                    { originalAuthor &&
                                                        <Form.Group className="field field-original-authorship">
                                                            <Form.Label>{ t("Original authorship") }</Form.Label>
                                                            <Form.Control type="text" plaintext readOnly value={ originalAuthor } />
                                                        </Form.Group>
                                                    }
                                                    <Form.Group className="field field-authorship">
                                                        <Form.Label>{ t("Author(s)") }</Form.Label>
                                                        <Form.Control type="text" name="authorship" required
                                                            value={ task.authorship } onChange={ handleAuthorshipChange } onBlur={ handleSaveProperties } />
                                                    </Form.Group>
                                                    { task._id != '' &&
                                                        <div className="task-tags">
                                                            <TaskTags taskId={ task._id } />
                                                        </div>
                                                    }
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="aim-of-the-task">
                                                        <Form.Group className="field field-aims">
                                                            <Form.Label>{ t("General aim of the task") }</Form.Label>
                                                            { aimsOfTask.map((a: any) => {
                                                                let checked = false;
                                                                if (task.aims !== undefined) {
                                                                    const index: number = task.aims.indexOf(a.value);
                                                                    if (index !== -1) {
                                                                        checked = true;
                                                                    }
                                                                }
                                                                return (
                                                                    <Form.Check type="checkbox" id={ 'general-aim-' + a.value }
                                                                        key={ 'general-aim-' + a.value } value={ a.value }
                                                                        checked={ checked }
                                                                        onChange={ handleChangeGeneralAim } label={ t(a.description) } />
                                                                )
                                                            })}
                                                            <Form.Control type="text" name="aim_other" required
                                                                value={ task.aim_other } onChange={ handleAimOtherChange } onBlur={ handleSaveProperties }
                                                                placeholder={ t("Other (please specify)") } />
                                                        </Form.Group>
                                                        <Form.Group className="field field-specific-aim">
                                                            <FormLabel htmlFor="specific_aim">{ t('Specific aim of the task') }</FormLabel>
                                                            <FormControl as="textarea" value={ task.specific_aim } name="goal" onChange={ handleChangeSpecificAim } onBlur={ handleSaveProperties } />
                                                            <div className="control-description">
                                                                { t("This information will be especially useful if you intend to share the task.") }
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="proficiency-level-of-the-task">
                                                        <Form.Group className="field field-proficiency-level">
                                                            <Form.Label>{ t("Student's proficiency level") }</Form.Label>
                                                            { proficiencyLevelsOfTask.map((a: any) => {
                                                                let checked = false;
                                                                if (task.proficiency_level !== undefined) {
                                                                    const index: number = task.proficiency_level.indexOf(a.value);
                                                                    if (index !== -1) {
                                                                        checked = true;
                                                                    }
                                                                }
                                                                return (
                                                                    <Form.Check type="checkbox" id={ 'proficiency-level-' + a.value }
                                                                        key={ 'proficiency-level-' + a.value } value={ a.value }
                                                                        checked={ checked }
                                                                        onChange={ handleChangeProficiencyLevel} label={ t(a.description) } />
                                                                )
                                                            })}
                                                        </Form.Group>
                                                        <Form.Group className="field field-proficiency-level-comments">
                                                            <FormLabel htmlFor="proficiency_level_comments">{ 'Comments' }</FormLabel> <Help id={ '654367be8fb78d09dce65ac6' } />
                                                            <FormControl as="textarea" value={ task.proficiency_level_comments } name="goal"
                                                                onChange={ handleChangeProficiencyLevelComments } onBlur={ handleSaveProperties } />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="lists row">
                                            <div className="list pre-tasks col-12 col-lg-4">
                                                <div className="list-inner">
                                                    <div className="heading">
                                                        <h2>{ t("Pre-Task") }</h2>
                                                    <div className="heading-actions">
                                                        <DropdownButton as={ ButtonGroup } title={ t("New Pre-Task") }
                                                            id="newPreTask">
                                                            <Dropdown.Item eventKey="1" onClick={ newPreTaskTextShow } title={ t("Use a text for reading comprehension and to highlight language input") }>{ t("Text") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="2" onClick={ newPreTaskAudioShow } title={ t("Audios are great sources of input.") }>{ t("Audio") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="3" onClick={ newPreTaskVideoShow } title={ t("Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.") }>{ t("Video") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="4" onClick={ newPreTaskDialogShow } title={ t("Reading comprehension dialogues provide an opportunity for both reading and speaking practice.") }>{ t("Written dialogue") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="5" onClick={ newPreTaskPhotoShow } title={ t("Photos provide excellent opportunities to generate communication and interaction.") }>{ t("Photo") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="6" onClick={ newPreTaskSpeechShow } title={ t("Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.") }>{ t("Speech transcript") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="7" onClick={ newPreTaskActivityShow } title={ t("Interaction activities can be used in preparation for the main task.") }>{ t("Interaction activity") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="8" onClick={ newPreTaskGameShow }>{ t("Game") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="9" onClick={ newPreTaskWarmUpShow } title={ t("Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.") }>{ t("Warm-up") }</Dropdown.Item>
                                                        </DropdownButton>
                                                    </div>
                                                </div>
                                                <div className="contents">
                                                    { task.pretasks.map((pt: PreTask, index) => {
                                                        return <PreTaskTeaser task_id={ task._id } task_language={ task.task_language } pretask={ pt } position={ index } key={ 'st-' + index }
                                                            deleteCallback={ handleDeletePretask } updateCallback={ handleUpdatePretask }
                                                            cloneCallback={ handleClonePretask } cloneAsCallback={ handleCloneAs }
                                                            sortUpCallback={ handleSortUpPretask } sortDownCallback={ handleSortDownPretask }  />
                                                    })}
                                                </div>
                                                </div>
                                            </div>
                                            <div className="list tasks col-12 col-lg-4">
                                                <div className="list-inner">
                                                    <div className="heading">
                                                        <h2>{ t("Main Task") } <Help id={ '650b0561b0f9abea03058849' } /></h2>
                                                    <div className="heading-actions">
                                                        <button className="btn btn-primary" onClick={ handleNewSubTask }>
                                                            { t("New Main Task") }
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="contents">
                                                    { task.tasks.map((st: SubTask, index) => {
                                                        return <SubTaskTeaser taskId={ task._id } task_language={ task.task_language } subtask={ st } key={ 'st-' + st._id } position={ index }
                                                            updateCallback={ handleUpdateSubtask } deleteCallback={ handleDeleteSubtask }
                                                            cloneCallback={ handleCloneSubTask }
                                                            sortUpCallback={ handleSortUpSubtask } sortDownCallback={ handleSortDownSubtask } />
                                                    })}
                                                </div>
                                                </div>
                                            </div>
                                            <div className="list post-tasks col-12 col-lg-4">
                                                <div className="list-inner">
                                                    <div className="heading">
                                                        <h2>{ t("Post-Task") }</h2>
                                                    <div className="heading-actions">
                                                        <DropdownButton as={ ButtonGroup } title={ t("New Post-Task") }
                                                            id="newPosTask">
                                                            <Dropdown.Item eventKey="1" onClick={ newPosTaskRepetitionShow } title={ t("Task repetition is known to have a positive impact on all aspects of production and learning.") }>{ t("Task repetition") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="2" onClick={ newPosTaskInteractionActivityShow } title={ t("Interaction activities can be used in preparation for the main task.") }>{ t("Interaction activity") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="3" onClick={ newPosTaskExplanationTextShow } title={ t("Explicit explanations can help solve or consolidate language issues that came up during task performance.") }>{ t("Explicit explanation") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="4" onClick={ newPosTaskReportShow }>{ t("Written to Oral / Oral to Written") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="5" onClick={ newPosTaskTMEShow }>{ t("Task model and exercises") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="6" onClick={ newPosTaskTeacherFeedbackShow }>{ 'Teacher feedback' }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="7" onClick={ newPosTaskExercisesShow }>{ t("Exercises") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="8" onClick={ newPosTaskTextShow } title={ t("Use a text for reading comprehension and to highlight language input") }>{ t("Text") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="9" onClick={ newPosTaskAudioShow } title={ t("Audios are great sources of input.") }>{ t("Audio") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="10" onClick={ newPosTaskVideoShow } title={ t("Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.") }>{ t("Video") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="11" onClick={ newPosTaskDialogShow } title={ t("Reading comprehension dialogues provide an opportunity for both reading and speaking practice.") }>{ t("Written dialogue") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="12" onClick={ newPosTaskPhotoShow } title={ t("Photos provide excellent opportunities to generate communication and interaction.") }>{ t("Photo") }</Dropdown.Item>
                                                            <Dropdown.Item eventKey="13" onClick={ newPosTaskGameShow }>{ t("Game") }</Dropdown.Item>
                                                        </DropdownButton>
                                                    </div>
                                                </div>
                                                <div className="contents">
                                                    {task.postasks.map((pt: PosTask, index) => {
                                                        return <PosTaskTeaser task_id={ task._id } task_language={ task.task_language } postask={ pt } position={ index } key={ 'st-' + pt._id }
                                                            updateCallback={ handleUpdatePosTask } deleteCallback={ handleDeletePosTask }
                                                            cloneCallback={ handleClonePostask } cloneAsCallback={ handleCloneAs }
                                                            sortUpCallback={ handleSortUpPostask } sortDownCallback={ handleSortDownPostask }  />
                                                    })}
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Pre tasks */}
            { showNewPreTaskText && <NewPreTaskText saveForm={ newPreTaskSave } closeForm={ newPreTaskTextHide } task_language={ task.task_language } /> }
            { showNewPreTaskAudio && <NewPreTaskAudio saveForm={ newPreTaskSave } closeForm={ newPreTaskAudioHide } task_language={ task.task_language } /> }
            { showNewPreTaskVideo && <NewPreTaskVideo saveForm={ newPreTaskSave } closeForm={ newPreTaskVideoHide } task_language={ task.task_language } /> }
            { showNewPreTaskDialog && <NewPreTaskDialog saveForm={ newPreTaskSave } closeForm={ newPreTaskDialogHide } task_language={ task.task_language } /> }
            { showNewPreTaskPhoto && <NewPreTaskPhoto saveForm={ newPreTaskSave } closeForm={ newPreTaskPhotoHide } task_language={ task.task_language } /> }
            { showNewPreTaskSpeech && <NewPreTaskSpeech saveForm={ newPreTaskSave } closeForm={ newPreTaskSpeechHide } task_language={ task.task_language } /> }
            { showNewPreTaskActivity && <NewPreTaskActivity saveForm={ newPreTaskSave } closeForm={ newPreTaskActivityHide } task_language={ task.task_language } /> }
            { showNewPreTaskGame && <NewPreTaskGame saveForm={ newPreTaskSave } closeForm={ newPreTaskGameHide } task_language={ task.task_language } /> }
            { showNewPreTaskWarmUp && <NewPreTaskWarmUp saveForm={ newPreTaskSave } closeForm={ newPreTaskWarmUpHide } task_language={ task.task_language } /> }
            {/* Post tasks */}
            { showNewPosTaskRepetition && <NewPosTaskRepetition saveForm={ newPosTaskSave } closeForm={ newPosTaskRepetitionHide } task_language={ task.task_language } /> }
            { showNewPosTaskInteractionActivity && <NewPosTaskInteractionActivity saveForm={ newPosTaskSave } closeForm={ newPosTaskInteractionActivityHide } task_language={ task.task_language } /> }
            { showNewPosTaskExplanationText && <NewPosTaskExplanationText saveForm={ newPosTaskSave } closeForm={ newPosTaskExplanationTextHide } task_language={ task.task_language } /> }
            { showNewPosTaskReport && <NewPosTaskReport saveForm={ newPosTaskSave } closeForm={ newPosTaskReportHide } task_language={ task.task_language } /> }
            { showNewPosTaskTME && <NewPosTaskTME saveForm={ newPosTaskSave } closeForm={ newPosTaskTMEHide } task_language={ task.task_language } /> }
            { showNewPosTaskTeacherFeedback && <NewPosTaskTeacherFeedback saveForm={ newPosTaskSave } closeForm={ newPosTaskTeacherFeedbackHide } task_language={ task.task_language } /> }
            { showNewPosTaskExercises && <NewPosTaskExercises saveForm={ newPosTaskSave } closeForm={ newPosTaskExercisesHide } task_language={ task.task_language } /> }
            { showNewPosTaskText && <NewPosTaskText saveForm={ newPosTaskSave } closeForm={ newPosTaskTextHide } task_language={ task.task_language } /> }
            { showNewPosTaskAudio && <NewPosTaskAudio saveForm={ newPosTaskSave } closeForm={ newPosTaskAudioHide } task_language={ task.task_language } /> }
            { showNewPosTaskVideo && <NewPosTaskVideo saveForm={ newPosTaskSave } closeForm={ newPosTaskVideoHide } task_language={ task.task_language } /> }
            { showNewPosTaskDialog && <NewPosTaskDialog saveForm={ newPosTaskSave } closeForm={ newPosTaskDialogHide } task_language={ task.task_language } /> }
            { showNewPosTaskPhoto && <NewPosTaskPhoto saveForm={ newPosTaskSave } closeForm={ newPosTaskPhotoHide } task_language={ task.task_language } /> }
            { showNewPosTaskGame && <NewPosTaskGame saveForm={ newPosTaskSave } closeForm={ newPosTaskGameHide } task_language={ task.task_language } /> }
        </MainLayout>
    );
}